<template>
  <layout>
    <div class="page-view">
      <banner
        :title="contTopInfo.name"
        :subtitle="contTopInfo.nameEn"
        :img="contTopInfo.picUrl" />
      <NavBar :navBar="navBar" />
      <div
        ref="layer1"
        class="title">
        软件定制
      </div>
      <div class="collapse">
        <div
          class="collapse-item"
          :key="index"
          v-for="(item, index) in infoRjAll">
          <div
            @click="item.openFlg = !item.openFlg"
            class="head">
            <span class="head-icon">
              <img
                :src="item.imgUrl"
                alt="" />
            </span>
            <span class="head-name">{{ item.name }}</span>
            <span
              :class="{
                'head-link': true,
                iconfont: true,
                'icon-right-1-copy': true,
                'head-link--active': item.openFlg,
              }"></span>
          </div>
          <div
            v-show="item.openFlg"
            class="multipleChoice">
            <el-checkbox-group
              v-model="item.fromValue"
              @change="customRjChange">
              <div
                class="multipleChoice-item"
                v-for="(item1, index1) in item.children"
                :key="index1">
                <el-checkbox :label="item1.id">
                  <div class="cont">
                    <div class="cont-name">{{ item1.name }}</div>
                    <div class="cont-desc">{{ item1.remarks }}</div>
                  </div>
                </el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <div
        ref="layer2"
        class="title">
        硬件定制
      </div>
      <div class="model">
        <div
          :class="{
            'model-item': true,
            'model-item--active': yjTabNum == index,
          }"
          :key="index"
          @click="yjTab(index)"
          v-for="(item, index) in infoYjAll">
          <div class="name">{{ item.name }}</div>
          <div class="modelPicture">
            <img
              :src="item.customImgs?.[item.imgNum].imgUrl"
              alt="" />
          </div>
          <div class="modelColor">
            <div
              @click="phoneImgClick(index, index1)"
              v-for="(item1, index1) in item.customImgs"
              :key="index1"
              :style="{ 'background-color': item1.imgColor }"
              :class="{
                'modelColor-item': true,
                'modelColor-item--active': item.imgNum == index1,
              }"></div>
          </div>
        </div>
      </div>
      <div class="collapse collapseB">
        <div
          class="collapse-item"
          :key="index"
          v-show="yjTabNum == index"
          v-for="(item, index) in infoYjAll">
          <div class="multipleChoice">
            <el-checkbox-group
              v-model="item.fromValue"
              @change="customYjChange">
              <div
                class="multipleChoice-item"
                v-for="(item1, index1) in item.hardwareCustomList"
                :key="index1">
                <el-checkbox :label="item1.id">
                  <div class="cont">
                    <div class="cont-name">{{ item1.name }}</div>
                    <div class="cont-desc">{{ item1.remarks }}</div>
                  </div>
                </el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <div class="subtitle">您已选择的定制内容</div>
      <div class="customize">
        <div
          class="customize-none"
          v-show="designateRjArr.length == 0 && designateYjArr.length == 0">
          <img
            src="https://oss.jingshucloud.com/gw-bucket/3bf709d0-2dac-4ddb-a1f9-ae2d8378d48f.png"
            alt="" />
          <div class="txt">您尚未选择定制内容</div>
        </div>
        <div
          class="customize-item"
          v-show="designateRjArr.length > 0 || designateYjArr.length > 0">
          <div class="title">软件定制</div>
          <ul class="list">
            <li
              class="list-item"
              :key="index"
              v-for="(item, index) in designateRjArr">
              <div class="name">{{ item.tit }}</div>
              <div class="item">{{ item.txt }}</div>
            </li>
          </ul>
          <div
            class="none"
            v-if="!designateRjArr.length > 0">
            <div class="none-txt">您尚未选择定制内容～</div>
            <div
              class="none-btn"
              @click="tapClic('layer1')">
              去选择
            </div>
          </div>
        </div>
        <div
          class="customize-item"
          v-show="designateRjArr.length > 0 || designateYjArr.length > 0">
          <div class="title">硬件定制</div>
          <ul class="list">
            <li
              class="list-item"
              :key="index"
              v-for="(item, index) in designateYjArr">
              <div class="name">{{ item.tit }}</div>
              <div class="item">{{ item.txt }}</div>
            </li>
          </ul>
          <div
            class="none"
            v-if="!designateYjArr.length > 0">
            <div class="none-txt">您尚未选择定制内容～</div>
            <div
              class="none-btn"
              @click="tapClic('layer2')">
              去选择
            </div>
          </div>
        </div>
      </div>
      <div class="subtitle">个人信息</div>
      <div class="formBox">
        <el-form
          :model="loginForm"
          :rules="rules"
          ref="loginForm">
          <div class="flex-box">
            <el-form-item
              label="姓名"
              prop="name">
              <el-input
                style="width: 100%"
                placeholder="请输入姓名"
                v-model="loginForm.name"></el-input>
            </el-form-item>
            <el-form-item
              label="邮箱"
              :prop="flgId == 1 ? 'eMail' : ''">
              <el-input
                style="width: 100%"
                placeholder="请输入邮箱"
                v-model="loginForm.eMail"></el-input>
            </el-form-item>
            <el-form-item
              label="单位详细地址"
              :prop="flgId == 1 ? '' : 'companyAddress'">
              <el-input
                style="width: 100%"
                placeholder="请输入单位详细地址"
                v-model="loginForm.companyAddress"></el-input>
            </el-form-item>
            <el-form-item
              label="电话"
              prop="tel">
              <el-input
                style="width: 100%"
                placeholder="请输入电话"
                v-model="loginForm.tel"></el-input>
            </el-form-item>
            <el-form-item
              label="单位名称"
              :prop="flgId == 1 ? '' : 'companyName'">
              <el-input
                style="width: 100%"
                placeholder="请输入单位名称"
                v-model="loginForm.companyName"></el-input>
            </el-form-item>
            <el-form-item
              v-if="flgId == 2"
              label="职务"
              prop="positions">
              <el-input
                style="width: 100%"
                placeholder="请输入职务"
                v-model="loginForm.positions"></el-input>
            </el-form-item>
          </div>
          <el-form-item label="附言">
            <el-input
              style="width: 100%"
              type="textarea"
              :rows="8"
              placeholder="请输入内容..."
              v-model="loginForm.positions"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="radioBox">
              <el-checkbox v-model="agreementRadio"></el-checkbox>
              <div class="radioBox-terms">
                我已阅读并同意<a href="">《京数服务协议条款》</a>
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div class="submit">
          <van-button
            class="submit-btn"
            type="primary"
            size="small"
            color="#04758E"
            @click="submitForm('loginForm')"
            >提交</van-button
          >
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import NavBar from '@/components/moblie/NavigationBar.vue';
import Layout from '@/components/moblie/Layout.vue';
import Banner from '@/components/banner.vue';
import { addCustomDemand } from '@/api/index';
export default {
  components: { Layout, Banner, NavBar },
  props: {
    navBar: {
      type: Array,
      default: () => {
        return [];
      },
    },
    infoYjAll: {
      type: Array,
      default: () => {
        return [];
      },
    },
    topPhoneArr: {
      type: Array,
      default: () => {
        return [];
      },
    },
    infoRjAll: {
      type: Array,
      default: () => {
        return [];
      },
    },
    contTopInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    rules: {
      type: Object,
      default: () => {
        return {};
      },
    },
    flgId: {
      type: String,
      default: '0',
    },
  },
  data() {
    return {
      yjTabNum: 0,
      designateRjArr: [],
      designateYjArr: [],
      agreementRadio: false,
      loginForm: {
        name: '',
        eMail: '',
        tel: '',
        companyName: '',
        positions: '',
        positions: '',
        companyAddress: '',
        demandContent: '',
        customId: localStorage.getItem('customizeId'),
      },
    };
  },
  methods: {
    yjTab(row) {
      this.topPhoneArr.forEach((item, index) => {
        if (index == row) {
          item.openFlg = true;
        } else {
          item.openFlg = false;
        }
      });
      this.yjTabNum = row;
    },
    phoneImgClick(row, num) {
      this.infoYjAll.forEach((item, index) => {
        if (row == index) {
          item.imgNum = num;
        }
      });
    },
    customRjChange(row) {
      // console.log(this.infoRjAll, row, "测试数据");
      this.designateRjArr = [];
      this.infoRjAll.forEach((element) => {
        let num =
          element.fromValue.length + '/' + element.children.length + '项';
        if (element.fromValue.length == element.children.length) {
          num = '全部';
        }
        if (element.fromValue.length > 0) {
          this.designateRjArr.push({
            tit: element.name,
            txt: num,
            value: element.fromValue,
          });
        }
      });
    },
    customYjChange(row) {
      this.designateYjArr = [];
      this.infoYjAll.forEach((element) => {
        let num =
          element.fromValue.length +
          '/' +
          element.hardwareCustomList.length +
          '项';
        if (element.fromValue.length == element.hardwareCustomList.length) {
          num = '全部';
        }
        if (element.fromValue.length > 0) {
          this.designateYjArr.push({
            tit: element.name,
            txt: num,
            value: element.fromValue,
          });
        }
      });
    },
    tapClic(sectionId) {
      const section = this.$refs[sectionId];
      if (section) {
        window.scrollTo({
          top: section.offsetTop,
          behavior: 'smooth', // 平滑滚动
        });
      }
    },
    submitForm(formName) {
      let demandContent = [];
      
      if (!this.agreementRadio) return this.$toast('请先同意条款后提交');
      if (this.designateYjArr.length > 0) {
        demandContent = demandContent.concat(
          this.designateYjArr[0].value,
          this.designateRjArr[0].value
        );
        this.loginForm.demandContent = demandContent.join(',');
      }

      if (!this.loginForm.demandContent) {
        this.$toast('请选择您的定制内容');
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addCustomDemand(this.loginForm).then((res) => {
            this.$toast('提交成功');
            this.infoRjAll.forEach((item) => {
              item.fromValue = [];
            });
            this.infoYjAll.forEach((item) => {
              item.fromValue = [];
            });
            this.designateYjArr[0].value = [];
            this.designateRjArr[0].value = [];
            this.loginForm = {
              name: '',
              eMail: '',
              tel: '',
              companyName: '',
              positions: '',
              positions: '',
              companyAddress: '',
              demandContent: '',
            };
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';
/* phone */
@media (max-width: $phone-max-size) {
  $container-width: 343px;
  .page-view {
    background: #f7f8fa;
    overflow: hidden;
    .title {
      font-weight: 700;
      font-size: 20px;
      color: #151a23;
      text-align: center;
      margin: 20px 0;
    }
    .subtitle {
      font-weight: 500;
      font-size: 13px;
      color: #151515;
      width: $container-width;
      margin: 0 auto 20px;
    }
    .collapse {
      width: $container-width;
      margin: 20px auto;
      &-item {
        padding: 0 12px;
        background: #ffffff;
        margin-bottom: 20px;
        .head {
          display: flex;
          align-items: center;
          padding: 14px 0;
          &-icon {
            width: 18px;
            margin-right: 10px;
            img {
              width: 100%;
            }
          }
          &-name {
            font-weight: 500;
            font-size: 12px;
            color: #151515;
            margin-right: auto;
          }
          .iconfont {
            font-size: 12px;
          }
          &-link {
            transform: rotate(90deg);
            transition: transform 0.3s;
          }
          &-link--active {
            transform: rotate(-90deg);
          }
        }
        .multipleChoice {
          border-top: 1px solid #e6e6e6;
          padding: 10px 0;
          &-item {
            display: flex;
            align-items: center;
            padding: 14px 16px;
            &:nth-of-type(odd) {
              background: rgb(244, 247, 251);
            }
            .el-checkbox {
              display: flex;
              align-items: center;
            }
            .cont {
              white-space: pre-wrap;
              &-name {
                font-weight: 500;
                font-size: 11px;
                color: #333333;
              }
              &-desc {
                font-weight: 400;
                font-size: 9px;
                color: #666666;
              }
            }
          }
        }
      }
    }
    .model {
      width: $container-width;
      margin: auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      &-item {
        overflow: hidden;
        width: 166px;
        padding: 20px 0;
        display: flex;
        border-radius: 4px 4px 4px 4px;
        flex-direction: column;
        align-items: center;
        margin-bottom: 11px;
        background: #ffffff;
        .name {
          font-weight: 500;
          font-size: 13px;
          color: #151a23;
          margin-bottom: 15px;
        }
        .modelPicture {
          margin-bottom: 10px;
          img {
            width: 80px;
            height: 80px;
            object-fit: contain;
          }
        }
        .modelColor {
          display: flex;
          &-item {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            margin-right: 6px;
            &:nth-last-of-type(1) {
              margin-right: 0;
            }
          }
          &-item--active {
            box-shadow: 0px 0px 0px 3px rgba(103, 142, 4, 0.1);
          }
        }
      }
      &-item--active {
        position: relative;
        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 6px;
          background: #048799;
        }
      }
    }
    .collapseB {
      .multipleChoice {
        border: none;
        &-item {
        }
      }
    }
    .customize {
      width: $container-width;
      margin: 0 auto 20px;
      background-color: #ffffff;
      padding: 10px;
      &-none {
        img {
          width: 120px;
          margin: 0 auto 12px;
        }
        .txt {
          font-weight: 400;
          font-size: 9px;
          color: #999999;
          text-align: center;
        }
      }
      &-item {
        margin-bottom: 16px;
        &:nth-last-of-type(1) {
          margin-bottom: 0;
        }
        .title {
          font-weight: 500;
          font-size: 13px;
          color: #333333;
          margin: 0;
          margin-bottom: 10px;
          text-align: left;
        }
        .list {
          &-item {
            padding: 10px 14px;
            background: #f9fafc;
            display: flex;
            justify-content: space-between;
            font-weight: 400;
            font-size: 11px;
            color: #666666;
          }
        }
        .none {
          text-align: center;
          &-txt {
            font-weight: 400;
            font-size: 9px;
            color: #9999;
            margin-bottom: 8px;
          }
          &-btn {
            padding: 5px 25px;
            font-weight: 400;
            font-size: 11px;
            color: #04758e;
            border: 1px solid #04758e;
            display: inline-block;
          }
        }
      }
    }
    .formBox {
      width: $container-width;
      margin: 20px auto 0;
      .radioBox {
        font-weight: 400;
        font-size: 10px;
        color: #151a23;
        display: flex;
        align-items: center;
        &-terms {
          color: #04758e;
          margin-left: 10px;
        }
      }
      .submit {
        text-align: center;
        margin-bottom: 30px;
        &-btn {
          min-width: 200px;
        }
      }
      ::v-deep .el-form {
        .el-form-item {
          margin-bottom: 15px;
          .el-form-item__label {
            font-weight: 400;
            color: #151a23;
            font-size: 13px;
            line-height: 30px;
          }
        }
      }
    }
  }
}
/* ipad */
@media (min-width: $ipad-min-size) and (max-width: $ipad-max-size) {
  $container-width: 700px;
  .page-view {
    background: #f7f8fa;
    overflow: hidden;
    .title {
      font-weight: 700;
      font-size: 20px;
      color: #151a23;
      text-align: center;
      margin: 20px 0;
    }
    .subtitle {
      font-weight: 700;
      font-size: 16px;
      color: #151515;
      width: $container-width;
      margin: 0 auto 20px;
    }
    .collapse {
      width: $container-width;
      margin: 20px auto;
      &-item {
        padding: 0 12px;
        background: #ffffff;
        margin-bottom: 20px;
        .head {
          display: flex;
          align-items: center;
          padding: 20px 0;
          &-icon {
            width: 20px;
            margin-right: 10px;
            img {
              width: 100%;
            }
          }
          &-name {
            font-weight: 700;
            font-size: 16px;
            color: #151515;
            margin-right: auto;
          }
          .iconfont {
            font-size: 15px;
          }
          &-link {
            transform: rotate(90deg);
            transition: transform 0.3s;
          }
          &-link--active {
            transform: rotate(-90deg);
          }
        }
        .multipleChoice {
          border-top: 1px solid #e6e6e6;
          padding: 10px 0;
          &-item {
            display: flex;
            align-items: center;
            padding: 14px 16px;
            &:nth-of-type(odd) {
              background: rgb(244, 247, 251);
            }
            .el-checkbox {
              display: flex;
              align-items: center;
            }
            .cont {
              white-space: pre-wrap;
              &-name {
                font-weight: 700;
                font-size: 14px;
                color: #333333;
              }
              &-desc {
                font-weight: 400;
                font-size: 12px;
                color: #666666;
              }
            }
          }
        }
      }
    }
    .model {
      width: $container-width;
      margin: auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      &-item {
        overflow: hidden;
        width: 220px;
        padding: 20px 0;
        display: flex;
        border-radius: 4px 4px 4px 4px;
        flex-direction: column;
        align-items: center;
        margin-bottom: 11px;
        background: #ffffff;
        .name {
          font-weight: 700;
          font-size: 16px;
          color: #151a23;
          margin-bottom: 15px;
        }
        .modelPicture {
          margin-bottom: 10px;
          img {
            width: 120px;
            height: 120px;
            object-fit: contain;
          }
        }
        .modelColor {
          display: flex;
          &-item {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            margin-right: 6px;
            &:nth-last-of-type(1) {
              margin-right: 0;
            }
          }
          &-item--active {
            box-shadow: 0px 0px 0px 3px rgba(103, 142, 4, 0.1);
          }
        }
      }
      &-item--active {
        position: relative;
        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 6px;
          background: #048799;
        }
      }
    }
    .collapseB {
      .multipleChoice {
        border: none;
        &-item {
        }
      }
    }
    .customize {
      width: $container-width;
      margin: 0 auto 20px;
      background-color: #ffffff;
      padding: 20px;
      display: flex;
      justify-content: center;
      &-none {
        img {
          width: 120px;
          margin: 0 auto 12px;
        }
        .txt {
          font-weight: 400;
          font-size: 12px;
          color: #999999;
          text-align: center;
        }
      }
      &-item {
        width: 48%;
        margin-bottom: 16px;
        &:nth-last-of-type(1) {
          // margin-bottom: 0;
          margin-left: auto;
        }
        .title {
          font-weight: 700;
          font-size: 16px;
          color: #333333;
          margin: 0;
          margin-bottom: 10px;
          text-align: left;
        }
        .list {
          &-item {
            padding: 10px 14px;
            background: #f9fafc;
            display: flex;
            justify-content: space-between;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
          }
        }
        .none {
          text-align: center;
          &-txt {
            font-weight: 400;
            font-size: 12px;
            color: #9999;
            margin-bottom: 8px;
          }
          &-btn {
            padding: 5px 25px;
            font-weight: 400;
            font-size: 14px;
            color: #04758e;
            border: 1px solid #04758e;
            display: inline-block;
          }
        }
      }
    }
    .formBox {
      width: $container-width;
      margin: 20px auto 0;
      .radioBox {
        font-weight: 400;
        font-size: 10px;
        color: #151a23;
        display: flex;
        align-items: center;
        &-terms {
          color: #04758e;
          margin-left: 10px;
        }
      }
      .flex-box {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .el-form-item {
          width: 48%;
        }
      }
      .submit {
        text-align: left;
        margin-bottom: 30px;
        &-btn {
          min-width: 140px;
        }
      }
      ::v-deep .el-form {
        .el-form-item {
          margin-bottom: 15px;
          .el-form-item__label {
            font-weight: 400;
            color: #151a23;
            font-size: 13px;
            line-height: 30px;
          }
        }
      }
    }
  }
}
</style>
